<template>
  <div>
    <MainLayout>
      <DetailForm
        title="New"
        description="This form will create a new teammate. If your Teammate already exists as a Candidate in Humaniz, make sure to mark the Candidate as Hired so that they are automatically converted to your team without you having to fill out duplicate information."
        action="Create"
        @handle-cancel="$router.go(-1)"
        @handle-action="createContact"
      >
        <TeammateForm :model-value="contact" @update:model-value="updateContact" />
      </DetailForm>
    </MainLayout>
  </div>
</template>

<script>
import MainLayout from '@/components/layouts/MainLayout/index.vue';
import DetailForm from '../shared/DetailForm.vue';
import TeammateForm from './TeammateForm.vue';
import { toast } from 'vue-sonner';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';
import RailsUtility from '@/utilities/rails';

export default {
  components: {
    MainLayout,
    DetailForm,
    TeammateForm,
  },
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      loading: true,
      contact: {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        licenseStatus: '',
        reLicenseNumber: '',
      },
    };
  },
  methods: {
    updateContact(value) {
      this.contact = value;
    },
    handleCancel() {
      this.$emit('cancel');
    },
    createContact() {
      const self = this;
      this.loadingSpinnerStore.showLocalLoadingSpinner();
      fetch('/api/teammates', {
        method: 'POST',
        body: JSON.stringify({
          first_name: self.contact.firstName,
          last_name: self.contact.lastName,
          phone_number: self.contact.phone,
          email: self.contact.email,
          license_status: RailsUtility.convertToCasedEnumFormat(self.contact.licenseStatus),
          re_license_number: self.contact.reLicenseNumber,
          record_type: 'Teammate',
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(async data => {
          this.loadingSpinnerStore.hideLocalLoadingSpinner();
          if (data.status != 'error') {
            await self.$router.push(`/team/${data.record.id}`);
            toast.success('Teammate created', {
              action: { label: 'Dismiss' },
              description:
                'Your teammate was successfully created.  Use the buttons below to view your new teammate, or dismiss this alert.',
            });
          } else {
            toast.error('Teammate create error', {
              action: { label: 'Dismiss' },
              description: data.message,
            });
          }
        });
    },
  },
};
</script>
